import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import "./Notification.scss";

const colorMap = {
  green: "green",
  red: "red"
};

const Notification = ({ children, color, title, onClose }) => (
  <div className={classnames("notification", colorMap[color])}>
    <div className="notification__title">{title}</div>
    <div className="notification__body">{children}</div>
    <i className="notification__close" onClick={onClose} />
  </div>
);

Notification.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func
};

export default Notification;
